import React from "react";
import "./ForgotPassword.scss";
import { Input, SVG, Text, NoData, Button } from "sunrise-ui";
import { Box, Grid } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import { regEmail } from "../../utilities/regx";
import { postForgotPasswordData } from "../../redux/reducers/users";
import { AppDispatch } from "../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../utilities/Loader";

const Forgotpassword = () => {
  const dispatch = useDispatch<AppDispatch>();
  // -----------loader state------------
  let [loading, setLoading] = React.useState(false);

  const [email, setEmail] = React.useState("");
  const [emailErr, setEmailErr] = React.useState(false);
  const forgotPasswordData = useSelector(
    (state: any) => state.USERS.forgotPasswordData
  );
  console.log(forgotPasswordData);
  const navigate = useNavigate();
  const handleSend = () => {
    if (!regEmail.test(email)) {
      setEmailErr(true);
      return;
    } else {
      let obj = {
        email: email,
      };
      if (loading === false) {
        setLoading(true);
        dispatch(
          postForgotPasswordData({ endPoint: "forgetPassword", data: obj })
        ).then((res) => {
          setLoading(false);
        });
      }
    }
  };

  React.useEffect(() => {
    if (email.length > 0 && forgotPasswordData?.status === 1) {
      navigate("/emailsent", { state: { email: email } });
      setEmail("");
    }
    // eslint-disable-next-line
  }, [forgotPasswordData]);

  React.useEffect(() => {
    setEmail("");
  }, []);

  return (
    <Box className="admin_forgot_wrapper">
      <Grid container>
        <Grid item xs={12}>
          <Grid className="d-flex h-center v-center pt1 pb1">
            <Grid>
              <SVG type="title" />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          md={5}
          xs={12}
          className="image_box d-flex h-center v-center"
        >
          <Grid>
            <NoData
              img="forgotPasswordImage"
              text="We have got your password. Don't worry just send your request."
            />
          </Grid>
        </Grid>
        <Grid
          item
          md={7}
          xs={12}
          className="forgot_col d-flex h-center v-center"
        >
          <Grid container className="forgot_box bg--white p2">
            <Grid item xs={12}>
              <Grid className="mb1">
                <Text
                  type={"normal"}
                  fontSize={24}
                  fonts={"normal"}
                  className="mb mt0 fw500"
                >
                  Forgot Password?
                </Text>
                <Text
                  type={"normal"}
                  fontSize={20}
                  fonts={"normal"}
                  className="fw400 mb0 mt0"
                >
                  Enter your email id below and you will receive your password.
                </Text>
              </Grid>
            </Grid>
            <Grid item xs={12} className="form-field">
              <Grid>
                <Text type={"normal"} fontSize={20} fonts={"normal"}>
                  Email Id*
                </Text>
                <Input
                  color={emailErr === true ? "danger" : "primary"}
                  fonts="normal"
                  placeholder="Enter Here"
                  value={email}
                  type="text"
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setEmailErr(false);
                  }}
                  className="email_input login_field"
                />
                <Text
                  type={`${emailErr ? "danger" : "normal"}`}
                  fonts="normal"
                  fontSize={14}
                  className={`info-text d-flex h-end ${
                    emailErr ? "" : "hidden"
                  }`}
                >
                  Entered wrong email
                </Text>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Grid className="mt1">
                <Button
                  type="button"
                  size="medium"
                  isRounded={true}
                  category="primary"
                  onClick={handleSend}
                  className="w100 login_button"
                >
                  {loading ? (
                    <Loader
                      color="#fff"
                      loading={loading}
                      size={8}
                      height="auto"
                    />
                  ) : (
                    "Send"
                  )}
                </Button>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid className="mt1 d-flex h-center">
                <Text
                  type="link"
                  fonts="normal"
                  fontSize={20}
                  onTextClick={() => {
                    navigate("/");
                  }}
                >
                  <span className="fw600">Login</span>
                </Text>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Forgotpassword;
